import { AxiosRequestConfig, GenericAbortSignal } from 'axios'
import { API_APPLICANT_URL, API_CANDIDATE_URL } from '../constants/base-urls'
import type {
  ICandidate,
  ICandidateByApplicant,
  ICandidateHistories,
  ICandidateToCreateEmployee,
  IPaginationParam,
  IPaginationResponse,
} from '../types'
import { createAxiosInstance } from '../utils'

const axios = createAxiosInstance({
  baseURL: API_CANDIDATE_URL,
  withAuth: true,
})

const axiosApplicant = createAxiosInstance({
  baseURL: API_APPLICANT_URL,
  withAuth: true,
})

type FetchCandidateParams = {
  education?: string
  position?: string
  province?: string
  vacancyId?: string
} & IPaginationParam

export const fetchPool = (params?: FetchCandidateParams, signal?: GenericAbortSignal) => {
  return axios.get<{ data: IPaginationResponse<ICandidate> }>(`/candidate`, { params, signal }).then((response) => response.data.data)
}

export const fetchCandidate = (id: string, config?: AxiosRequestConfig) => {
  return axios.get<{ data: ICandidate }>(`/candidate/profile/${id}`, config).then((response) => response.data.data)
}

export const downloadCandidate = (payload: Record<string, any>) => {
  return axios
    .get(`/candidate/export`, {
      params: payload,
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      return response
    })
}

export const fetchCandidateToCreateEmployeeByApplicanId = (oid: string, config?: AxiosRequestConfig) => {
  return axios.get<{ data: ICandidateToCreateEmployee }>(`/candidate/${oid}`, config).then((response) => response.data.data)
}

export const fetchCandidateByApplicantId = (oid: string, config?: AxiosRequestConfig) => {
  return axios.get<{ data: ICandidateByApplicant }>(`/candidate/${oid}`, config).then((response) => response.data.data)
}

export const fetchDetailCandidate = (oid?: string, signal?: GenericAbortSignal) => {
  return axios.get<{ data: ICandidateHistories }>(`/candidate/history/${oid}`, { signal }).then((response) => response.data.data)
}

export const offerCandidateExplore = (payload: Record<string, any>) => {
  return axiosApplicant.post(`/applicant/offer`, payload).then((response) => response.data)
}

export const uploadResumeCandidate = async (payload: Record<string, any>) => {
  return axios.post<{ data: { user: ICandidate } }>('/candidate/upload-resume', payload).then(({ data }) => data)
}

export const completeCandidateProfile = (candidateId: string) => {
  return axios.post(`/candidate/${candidateId}/reminders/complete-profile`).then(({ data }) => data)
}

export const importCandidate = async (payload: Record<string, any>) => {
  return axios.post('/candidate/import', payload).then(({ data }) => data)
}
